import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getNoCatch, post, postNoCatch } from '@api/request';
import { rfidAPI } from '@api/modules/rfid'; //rfid

import pubPagination from '@/components/common/pubPagination';
import selectSectionType from '@/views/component/selectSectionType';
import { muopAPI } from '@api/modules/muop';
export default {
  name: 'muopCard',
  components: {
    pubPagination: pubPagination,
    selectSectionType: selectSectionType
  },
  data: function data() {
    return {
      muopForm: {
        page_no: 1
      },
      total: 0,
      cardList: [],
      multipleSelection: [],
      defaultValType: '',
      selectRefuDisabled: false,
      isDyj: true,
      beloDeptId: null,
      options: [{
        value: 0,
        label: '未使用'
      }, {
        value: 1,
        label: '已完成'
      }, {
        value: 2,
        label: '正在使用'
      }]
    };
  },
  watch: {
    $route: function $route(to, from) {
      if (from.path === '/muop_list') {
        this.getCardList();
      }
    }
  },
  created: function created() {
    this.getCardList();
  },
  methods: {
    getCardList: function getCardList() {
      var _this = this;

      getNoCatch(muopAPI.getMurfs, this.muopForm).then(function (_ref) {
        var data = _ref.data;
        _this.cardList = data.list;
        _this.total = data.total;
      });
    },
    changeSampPageSearch: function changeSampPageSearch(val) {
      this.muopForm.page_no = val;
      this.getCardList();
    },
    searFrom: function searFrom() {
      this.muopForm.page_no = 1;
      this.$refs.pubPagination.currentPage = 1;
      this.getCardList();
    },
    // 刷新
    buttonRefresh: function buttonRefresh() {
      this.muopForm = {
        page_no: 1
      };
      this.currentPage = 1;
      this.$refs.pubPagination.currentPage = 1;
      this.getCardList();
    },
    addCard: function addCard() {
      this.jump('muop_add');
    },
    delCard: function delCard() {
      var _this2 = this;

      if (this.multipleSelection.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }

      this.$confirm('此操作将永久删除该卡号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var murf_id_list = _this2.multipleSelection.map(function (_ref2) {
          var murf_id = _ref2.murf_id;
          return Object.values({
            murf_id: murf_id
          }).toString();
        });

        post(muopAPI.destroyMurfByIds, {
          murf_id_list: murf_id_list
        }).then(function (res) {
          if (res.data.code === 1) {
            return _this2.$message.warning('状态是正在使用或已完成的卡是不可以销卡');
          }

          if (res.data.code !== 0) {
            return _this2.$message.error(res.data.msg);
          }

          _this2.$message.success(res.data.msg);

          _this2.getCardList();
        });
      }).catch(function () {
        _this2.$message.info('已取消删除');
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    dblclick: function dblclick(val) {
      console.log(val);
      this.jump('muop_edit', {
        murf_id: val.murf_id
      });
    },
    //查询范围
    getStatusVal2: function getStatusVal2(val) {
      this.muopForm.belo_dept_id = val;
    },
    //升序 降序
    sortChange: function sortChange(val) {
      if (val.order == 'ascending') {
        this.muopForm.muop_sort = 'asc';
        this.muopForm.muop_field = val.prop;
      } else if (val.order == 'descending') {
        this.muopForm.muop_sort = 'desc';
        this.muopForm.muop_field = val.prop;
      } else {
        this.muopForm.muop_sort = '';
        this.muopForm.muop_field = '';
      }

      this.muopForm.page_no = 1;
      this.getCardList(); // 升序 asc
      // 降序 desc
    },
    //获取卡的状态
    getRfidStatus: function getRfidStatus(status) {
      if (status === 0) {
        return '正在使用';
      } else if (status === 1) {
        return '已完成';
      } else if (status === 2) {
        return '未使用';
      }
    },
    //通过状态改变 tag的颜色
    getRfidType: function getRfidType(status) {
      if (status === 0) {
        return '';
      } else if (status === 1) {
        return 'success';
      } else if (status === 2) {
        return 'warning';
      }
    }
  },
  computed: {
    isDisabled: function isDisabled() {
      if (this.multipleSelection.length == 0) {
        return true;
      }

      var f = this.multipleSelection.some(function (item) {
        return item.rfid_status === 1;
      });
      return f;
    }
  }
};